














import Vue from "vue";
import { required, requiredIf } from "vuelidate/lib/validators";
import dialog from "@/common/mixins/dialog";
import MarketplaceStopSyncEditorForm from "../components/MarketplaceStopSyncEditorForm.vue";
import { MarketplaceStopSyncCreateForm } from "../forms/MarketplaceStopSyncCreateForm";
import { Shop } from "../../shop/models/Shop";

export default Vue.extend({
  mixins: [dialog],
  components: {
    MarketplaceStopSyncEditorForm
  },
  validations: {
    marketplaceStopSyncCreateForm: {
      shop: { required },
      fromDate: {
        required: requiredIf(function(this: any) {
          return !this.marketplaceStopSyncCreateForm.isStartImmediately;
        })
      },
      untilDate: { required }
    }
  },
  data() {
    const shops: Shop[] = [];
    const marketplaceStopSyncCreateForm: MarketplaceStopSyncCreateForm = {
      marketplaceName: "shopee",
      isStartImmediately: false
    };

    return { shops, marketplaceStopSyncCreateForm };
  },
  async created() {
    await Promise.all([this.getShops()]);
  },
  methods: {
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    goToMarketplaceStopSyncViewPage() {
      this.$router.push({ name: "MarketplaceStopSyncViewPage" });
    },
    async createMarketplaceStopSync() {
      try {
        await (this as any).$dep.marketplaceUseCase.createMarketplaceStopSync(
          this.marketplaceStopSyncCreateForm
        );

        if (
          await (this as any).alertSuccess(
            "Success",
            "หยุดการ Sync ชั่วคราวสำเร็จ"
          )
        ) {
          this.goToMarketplaceStopSyncViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError(
                "Error",
                "ไม่สามารถหยุดการ Sync ชั่วคราวได้"
              )
            : (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to stop sync",
        "คุณต้องการหยุดการ Sync ชั่วคราวหรือไม่ ?"
      );

      if (isConfirmed) {
        await this.createMarketplaceStopSync();
      }
    },
    clear() {
      this.$v.$reset();
      this.marketplaceStopSyncCreateForm = {
        marketplaceName: "shopee",
        isStartImmediately: false
      };
    }
  }
});
